import HousekeepingStatusBoardDispatcher from "../dispatcher/HousekeepingStatusBoardDispatcher";

var HousekeepingStatusBoardConstants = {
  INIT: 'init',
  CHANGE_EVENT: 'changeEvent',
  GOTO_DATE: 'gotoDate',
};
export default HousekeepingStatusBoardConstants

